var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center mt-3"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{class:`mr-1 ${_vm.bold ? 'font-weight-bold' : ''}`},[_vm._v(" "+_vm._s(_vm.label)+":")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }